import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { wsReadyState, activeScopeState } from "../global-state";
import ImportantToast from "../common/important-toast";
import { useAppInterface } from "../app/app-interface-provider";

const WebSocketConnectionToast = () => {
  const wsReady = useRecoilValue(wsReadyState);
  const activeScope = useRecoilValue(activeScopeState);
  const appInterface = useAppInterface();

  // List of paths where we don't want to show the toast
  const excludedPaths = [
    "/user-login",
    "/user-login-callback",
    "/user-logout",
    "/developer-logout",
    "/developer-login",
    "/developer-login-callback",
    "/init-scope",
    "/desktop-auth-wait",
    "/desktop-auth-done",
  ];

  useEffect(() => {
    console.log("wsReady", wsReady);
  }, [wsReady]);

  // Check if WebSocket is open
  const checkWebSocketOpen = () => {
    return wsReady;
  };

  const handleAction = () => {
    // Call appInterface.refreshWebsocketConnection if available
    if (appInterface && appInterface.isAvailable()) {
      window.onWsReady = null;
      appInterface.refreshWebsocketConnection();
    }
    window.location.reload();
  };

  return (
    <ImportantToast
      isOpen={!wsReady}
      onAction={handleAction}
      message="Reconnecting..."
      actionButtonText="Reload App"
      excludedPaths={excludedPaths}
      checkCondition={checkWebSocketOpen}
      delay={2000}
    />
  );
};

export default WebSocketConnectionToast;
